const header = "_275h14kefu";
const spacer = "_275sd4gmw0";
const supportCls = "_275s1hqd2md";
const supportIconCls = "_275sgdmypb";

export { header, spacer, supportCls, supportIconCls };
import "./atom.header.style.linaria.module.css";
//# sourceMappingURL=atom.header.style.js.map
